export type LegalMetaItem = {
  label: string;
  value: string;
};

export type LegalBlock =
  | { type: 'heading'; level: 2 | 3; text: string }
  | { type: 'paragraph'; text: string }
  | { type: 'list'; items: string[] }
  | { type: 'table'; rows: string[][] };

export type LegalDocument = {
  slug: string;
  path: string;
  label: string;
  title: string;
  description: string;
  meta: LegalMetaItem[];
  blocks: LegalBlock[];
};

export const legalDocuments = [
  {
    "slug": "aszf",
    "path": "/aszf/",
    "label": "ÁSZF",
    "title": "Általános Szerződési Feltételek",
    "description": "Az Orienta Általános Szerződési Feltételei, hatályos szerződéses feltételek és szolgáltatási szabályok.",
    "meta": [
      {
        "label": "Utolsó módosítás",
        "value": "2026. június 1."
      },
      {
        "label": "Verzió",
        "value": "1.1"
      },
      {
        "label": "Szolgáltató",
        "value": "Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság"
      },
      {
        "label": "Weboldal",
        "value": "https://orientaplatform.eu"
      }
    ],
    "blocks": [
      {
        "type": "heading",
        "level": 2,
        "text": "1. Bevezetés, a szerződés célja és hatálya"
      },
      {
        "type": "paragraph",
        "text": "1.1. Jelen Általános Szerződési Feltételek az Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság által üzemeltetett Orienta elnevezésű digitális szolgáltatás használatának szerződéses feltételeit tartalmazzák."
      },
      {
        "type": "paragraph",
        "text": "1.2. Az ÁSZF célja, hogy egyértelműen meghatározza a szolgáltatás igénybevételének jogi, technikai, fizetési, felelősségi, adatvédelmi és felhasználási kereteit, ideértve az Ügyfél, a Felhasználók és a Szolgáltató jogait és kötelezettségeit."
      },
      {
        "type": "paragraph",
        "text": "1.3. Az ÁSZF hatálya kiterjed minden olyan természetes személyre, jogi személyre és jogi személyiség nélküli szervezetre, aki vagy amely az Orientát regisztrációval, megrendeléssel, előfizetéssel, meghívó alapján, ingyenes próbaidőben, beta hozzáférésben vagy bármely más módon igénybe veszi."
      },
      {
        "type": "paragraph",
        "text": "1.4. Az ÁSZF, az Adatkezelési Tájékoztató, a Cookie és SDK Tájékoztató, a díjcsomag vagy megrendelés, valamint az egyedi írásbeli megállapodás együttesen irányadóak. Eltérés esetén az egyedi írásbeli megállapodás elsőbbséget élvez; fogyasztó esetén a kötelező fogyasztóvédelmi szabályoktól a Fogyasztó hátrányára eltérni nem lehet."
      },
      {
        "type": "paragraph",
        "text": "1.5. Az Orienta funkcióira és szolgáltatási tartalmára jelen ÁSZF szolgáltatásleírása az irányadó. Az adatkezelési dokumentumok ezt a funkcionális tényállást követik."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "2. A Szolgáltató adatai"
      },
      {
        "type": "table",
        "rows": [
          [
            "Szolgáltató neve",
            "Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság"
          ],
          [
            "Székhely",
            "2013 Pomáz, Rozmaring utca 5."
          ],
          [
            "Levelezési cím",
            "2013 Pomáz, Rozmaring utca 5."
          ],
          [
            "Cégjegyzékszám",
            "13-09-196494"
          ],
          [
            "Adószám",
            "26581840-2-13"
          ],
          [
            "Képviselő",
            "Édes Gábor"
          ],
          [
            "E-mail",
            "info@orientaplatform.eu"
          ],
          [
            "Telefon",
            "+36 70 607 2310"
          ],
          [
            "Weboldal",
            "https://orientaplatform.eu"
          ],
          [
            "Ügyfélszolgálat",
            "https://orientaplatform.eu/kapcsolat/"
          ],
          [
            "Panaszkezelési cím",
            "panasz@orientaplatform.eu"
          ],
          [
            "Adatvédelmi kapcsolattartó",
            "adatvedelem@orientaplatform.eu"
          ],
          [
            "DSA kapcsolattartási pont",
            "dsa@orientaplatform.eu"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "3. Fogalmak"
      },
      {
        "type": "table",
        "rows": [
          [
            "Alkalmazás",
            "az Orienta webes, API, admin vagy más digitális felülete, amelyen keresztül a Szolgáltatás elérhető."
          ],
          [
            "Szolgáltatás",
            "a Szolgáltató által nyújtott digitális szolgáltatás, szoftver-hozzáférés, tárhely, fiók, jogosultság, forrásfeldolgozás, döntéstámogató kiértékelés, export, értesítés, támogatás és kapcsolódó szolgáltatás, beleértve az ingyenes vagy próba funkciókat is."
          ],
          [
            "Ügyfél",
            "az a természetes személy, jogi személy vagy jogi személyiség nélküli szervezet, aki vagy amely a Szolgáltatást megrendeli, előfizeti, aktiválja vagy szerződő félként igénybe veszi."
          ],
          [
            "Felhasználó",
            "az Ügyfél, illetve az Ügyfél által meghívott vagy engedélyezett természetes személy, aki a Szolgáltatást használja."
          ],
          [
            "Adminisztrátor",
            "az Ügyfél által kijelölt Felhasználó, aki jogosult a szervezeti fiók, jogosultságok, meghívók, adatok vagy beállítások kezelésére."
          ],
          [
            "Fogyasztó",
            "az a természetes személy, aki szakmája, önálló foglalkozása vagy üzleti tevékenysége körén kívül jár el."
          ],
          [
            "Előfizetés vagy Díjcsomag",
            "az Ügyfél által választott, meghatározott időtartamra, funkciókra, felhasználószámra, használati keretre vagy egyéb paraméterekre vonatkozó szolgáltatási csomag."
          ],
          [
            "Szervezeti dosszié",
            "az Ügyfél szervezetéhez kapcsolódó újrahasznosítható profil, ideértve többek között a jogi azonosítókat, tevékenységi kódokat, telephelyeket, pénzügyi és létszámadatokat, támogatási előzményeket, képviseleti és aláírási adatokat, bizonyítékokat és dokumentumokat."
          ],
          [
            "Projektbrief",
            "az Ügyfél konkrét beruházási, fejlesztési, finanszírozási, beszállítói vagy egyéb projektötletének strukturált leírása."
          ],
          [
            "Jogosultsági eredmény",
            "az Orienta szabálymotorja vagy manuális felülvizsgálata által előállított döntéstámogató eredmény, amely státuszt, indokolást, forrás- vagy bizonyítékhivatkozást, bizalmi szintet és következő lépést tartalmazhat."
          ],
          [
            "Felhasználói Tartalom",
            "minden adat, szöveg, dokumentum, üzleti adat, projektadat, üzenet, feladat, riport, fájl vagy más tartalom, amelyet az Ügyfél vagy Felhasználó a Szolgáltatásba feltölt, azon keresztül létrehoz, továbbít, tárol vagy megoszt."
          ],
          [
            "Harmadik Fél Szolgáltatás",
            "olyan tárhely, infrastruktúra, e-mail, fizetési, számlázási, analitikai, AI, hirdetési vagy más külső megoldás, amelyet nem a Szolgáltató üzemeltet."
          ],
          [
            "Adatfeldolgozási Megállapodás",
            "jelen ÁSZF mellékleteként alkalmazandó GDPR 28. cikk szerinti feltételrendszer arra az esetre, ha a Szolgáltató az Ügyfél nevében személyes adatokat dolgoz fel."
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "4. A szerződés létrejötte és az ÁSZF elfogadása"
      },
      {
        "type": "paragraph",
        "text": "A szerződés az Ügyfél és a Szolgáltató között a regisztráció jóváhagyásával, a meghívó elfogadásával, a megrendelés leadásával, az Előfizetés aktiválásával, a fizetés teljesítésével, az ingyenes próbaidő vagy beta hozzáférés indításával, illetve a Szolgáltatás tényleges használatának megkezdésével jön létre."
      },
      {
        "type": "paragraph",
        "text": "Fizetős szolgáltatás megrendelésekor az Ügyfélnek az ÁSZF-et, az Adatkezelési Tájékoztatót és a fizetési kötelezettséget egyértelműen el kell fogadnia. A megrendelési folyamatnak kifejezetten jeleznie kell, hogy a megrendelés fizetési kötelezettséggel jár."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél kijelenti, hogy az általa megadott adatok valósak és naprakészek, továbbá szervezet nevében eljárva jogosult a szerződés megkötésére és a Felhasználók hozzáférésének biztosítására."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató jogosult a regisztrációt, megrendelést vagy hozzáférést elutasítani vagy további azonosítást kérni, ha az adatok hiányosak, valótlanok, jogsértő használat gyanúja merül fel, vagy a Szolgáltatás nyújtását jogszabály, hatósági intézkedés vagy üzleti kockázat indokolja."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél felel azért, hogy a hozzá tartozó Felhasználók megismerjék és betartsák az ÁSZF-et, a belső jogosultsági szabályokat és az adatvédelmi követelményeket."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "5. A Szolgáltatás leírása"
      },
      {
        "type": "paragraph",
        "text": "5.1. Az Orienta fő célja, hogy a közfinanszírozási és pályázati lehetőségek bonyolultságát bizonyítékokra épülő jogosultsági előszűréssé, strukturált előkészítéssé, feladatokká és beadásra előkészített handoff csomaggá alakítsa magyar KKV-k, egyéni vállalkozók, tanácsadók és későbbi EU/konzorciumi felhasználási esetek számára."
      },
      {
        "type": "paragraph",
        "text": "5.2. A Szolgáltatás fő funkciói különösen:"
      },
      {
        "type": "paragraph",
        "text": "regisztráció, bejelentkezés, szervezeti fiók, meghívó és jogosultságkezelés;"
      },
      {
        "type": "paragraph",
        "text": "szervezeti dosszié és projektbrief létrehozása, szerkesztése és újrahasznosítása;"
      },
      {
        "type": "paragraph",
        "text": "pályázati és finanszírozási lehetőségek forrásalapú feldolgozása, listázása és keresése;"
      },
      {
        "type": "paragraph",
        "text": "determinista szabálymotoron vagy manuális felülvizsgálaton alapuló jogosultsági és illeszkedési eredmények;"
      },
      {
        "type": "paragraph",
        "text": "bizonyíték-, forrás-, nyers snapshot- és magyarázatmegjelenítés, ahol az adott funkció ezt támogatja;"
      },
      {
        "type": "paragraph",
        "text": "hiányzó adatok, pótolható hiányok, kizáró okok, ellenőrzendő esetek és következő lépések kezelése;"
      },
      {
        "type": "paragraph",
        "text": "readiness/action center, feladatok, dokumentum- és csatolmánylista, exportálható előkészítési csomag;"
      },
      {
        "type": "paragraph",
        "text": "tanácsadói vagy adminisztrátori munkatér, review queue és audit láthatóság, ha az adott díjcsomagban engedélyezett;"
      },
      {
        "type": "paragraph",
        "text": "opcionális AI-asszisztált összefoglalás, kivonatolás, fogalmazás vagy magyarázati szöveg, amely nem helyettesíti a szabálymotor vagy a manuális felülvizsgálat döntését."
      },
      {
        "type": "paragraph",
        "text": "5.3. A Szolgáltatás pontos funkciói, keretei, korlátai, díjai és technikai paraméterei a mindenkori szolgáltatásleírásban, díjcsomagban, alkalmazáson belüli tájékoztatásban vagy egyedi megrendelésben szerepelnek."
      },
      {
        "type": "paragraph",
        "text": "5.4. Az Orienta nem minősül jogi, pénzügyi, adózási, pályázatírói, hatósági vagy más szabályozott szakmai tanácsadásnak. A Szolgáltatás döntéstámogató és előkészítő eszköz; nem hivatalos hatóság, nem támogatás- vagy jogosultsággarancia, és nem hivatalos benyújtási rendszer."
      },
      {
        "type": "paragraph",
        "text": "5.5. Az Orienta által előállított jogosultsági vagy readiness státuszok nem váltják ki az Ügyfél, a tanácsadó, a jogi/pénzügyi szakértő vagy a hivatalos döntéshozó ellenőrzését. A hivatalos beadás és minden hatósági, pályázatkezelői vagy támogatói döntés külső rendszerben és külső eljárásban történik."
      },
      {
        "type": "paragraph",
        "text": "5.6. A Szolgáltató jogosult a Szolgáltatás funkcióit fejleszteni, módosítani, összevonni, kivezetni vagy új funkciókkal bővíteni. Lényeges, hátrányos változásról a Szolgáltató az ÁSZF módosítására vonatkozó szabályok szerint tájékoztatja az Ügyfelet."
      },
      {
        "type": "paragraph",
        "text": "5.7. A Szolgáltató külön díj, előfizetés vagy jogosultsági szint alapján tehet elérhetővé kiegészítő modulokat, integrációkat, AI-asszisztált funkciókat, tanácsadói felületet, adminisztrátori felületet vagy magasabb használati kereteket."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "6. Regisztráció, fiókok és jogosultságok"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltatás használatához regisztráció, meghívó, szervezeti fiók, e-mail azonosítás, egyszeri kód, jelszó, Google-bejelentkezés, Supabase Auth alapú hitelesítés vagy más engedélyezett belépési mód szükséges lehet."
      },
      {
        "type": "paragraph",
        "text": "A fiók személyhez vagy szervezethez kötött. Belépési adatok, jelszavak, tokenek, API-kulcsok, meghívókódok és adminisztrátori hozzáférések harmadik személy részére történő átadása tilos, kivéve, ha ezt a Szolgáltató kifejezetten engedélyezi."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél felel saját szervezeti fiókjában a jogosultságokért, a Felhasználók meghívásáért, eltávolításáért, szerepköreiért, valamint azért, hogy a már nem jogosult személyek hozzáférését késedelem nélkül megszüntesse."
      },
      {
        "type": "paragraph",
        "text": "A Felhasználó köteles biztonságos jelszót használni, belépési adatait bizalmasan kezelni, és haladéktalanul értesíteni a Szolgáltatót, ha jogosulatlan hozzáférés, adatvédelmi incidens vagy visszaélés gyanúja merül fel."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató jogosult biztonsági okból jelszócserét, többfaktoros azonosítást, hozzáférés-újraigazolást vagy fiókzárolást előírni."
      },
      {
        "type": "paragraph",
        "text": "16 év alatti személy önállóan nem regisztrálhat. Ha a Szolgáltatás valamely szervezeti Ügyfélen keresztül 16 év alatti személy adatát érinti, az Ügyfél felel a megfelelő jogalapért, tájékoztatásért és törvényes képviselői hozzájárulásért."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "7. Díjcsomagok, fizetés és számlázás"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltatás díjai, csomagjai, fizetési ütemezése, próbaidőszaka, beta feltételei, kedvezményei és használati keretei a weboldalon, az alkalmazásban, az egyedi ajánlatban vagy a megrendelési folyamatban kerülnek feltüntetésre."
      },
      {
        "type": "paragraph",
        "text": "Fogyasztóknak közzétett árak bruttó árak. Vállalkozásoknak az árak nettó díjként és az ÁFA külön feltüntetésével is szerepelhetnek."
      },
      {
        "type": "paragraph",
        "text": "A fizetés banki átutalással, bankkártyával, Stripe-on keresztül, app store-on keresztül vagy a Szolgáltató által elérhetővé tett más fizetési móddal történhet. A Szolgáltató teljes bankkártyaadatot nem tárol; bankkártyás fizetés esetén a fizetési adatokat a fizetési szolgáltató kezeli."
      },
      {
        "type": "paragraph",
        "text": "Előfizetés esetén a díjfizetés havi, éves vagy egyedi időszakra vonatkozhat. Automatikusan megújuló előfizetés esetén az előfizetés az aktuális időszak végén megújul, kivéve, ha az Ügyfél azt a következő számlázási időszak kezdete előtt legalább egy nappal lemondja."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató elektronikus számlát állít ki a Számlázz.hu platformon keresztül. A számlázási adatok NAV Online Számla rendszerébe továbbításra kerülnek."
      },
      {
        "type": "paragraph",
        "text": "Késedelmes fizetés esetén a Szolgáltató jogosult fizetési emlékeztetőt küldeni, a fizetős funkciókat korlátozni, a hozzáférést felfüggeszteni, illetve követelését jogi úton érvényesíteni. Fogyasztó esetén a kötelező fogyasztóvédelmi szabályok irányadók."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "8. Fogyasztói jogok, elállás és digitális szolgáltatás"
      },
      {
        "type": "paragraph",
        "text": "8.1. Ha az Ügyfél Fogyasztóként köt szerződést, a távollevők között kötött szerződésekre és digitális szolgáltatásokra vonatkozó kötelező fogyasztóvédelmi szabályok irányadóak."
      },
      {
        "type": "paragraph",
        "text": "8.2. A Fogyasztó főszabály szerint 14 napon belül indokolás nélkül elállhat a szerződéstől. Digitális szolgáltatás esetén a Fogyasztó tudomásul veszi, hogy ha kifejezett előzetes hozzájárulásával a Szolgáltató a teljesítést a 14 napos határidő lejárta előtt megkezdi, és a Fogyasztó tudomásul veszi az elállási jog elvesztését a teljesített digitális szolgáltatás tekintetében, az elállási jog korlátozottan vagy nem gyakorolható a már teljesített szolgáltatásra."
      },
      {
        "type": "paragraph",
        "text": "8.3. Részben teljesített vagy időarányos előfizetés esetén a visszatérítésre a jogszabályi rendelkezések, a megrendelés és az adott díjcsomag feltételei irányadóak. A jogszabály alapján járó fogyasztói jogokat jelen ÁSZF nem korlátozza."
      },
      {
        "type": "paragraph",
        "text": "8.4. Elállási vagy panaszbejelentés a panasz@orientaplatform.eu e-mail címen vagy a https://orientaplatform.eu/kapcsolat/ felületen, továbbá a dedikált Elállás a szerződéstől oldalon nyújtható be."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "9. Felhasználói tartalom, üzleti adatok, dokumentumok és jogszerű használat"
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél és a Felhasználó kizárólag jogszerű, valós, pontos és a Szolgáltatás céljával összeegyeztethető Felhasználói Tartalmat tölthet fel vagy kezelhet."
      },
      {
        "type": "paragraph",
        "text": "Tilos jogellenes, személyiségi jogot, szerzői jogot, üzleti titkot, titoktartási kötelezettséget, pályázati vagy hatósági eljárási szabályt vagy más jogot sértő tartalom feltöltése, tárolása, továbbítása vagy megosztása."
      },
      {
        "type": "paragraph",
        "text": "A dokumentumfeltöltés célja pályázati, támogatási, finanszírozási és üzleti előkészítési adatok, bizonyítékok és csatolmányok kezelése. Különleges személyes adat, egészségügyi adat, biometrikus adat, gyermekekre vonatkozó érzékeny adat vagy más fokozott kockázatú adat feltöltése csak akkor megengedett, ha az Ügyfél rendelkezik megfelelő jogalappal és a jogszabályi feltételekkel."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél felel azért, hogy az Orientába bevitt szervezeti, pénzügyi, projekt-, támogatási, partner-, képviseleti és dokumentumadatok helyesek, naprakészek és ellenőrzöttek legyenek. A téves vagy hiányos adatok téves döntéstámogató eredményhez, hiányos csomaghoz vagy hibás következő lépéshez vezethetnek."
      },
      {
        "type": "paragraph",
        "text": "A Felhasználói Tartalomért elsődlegesen az azt feltöltő vagy kezelő Ügyfél, illetve Felhasználó felel. A Szolgáltató nem köteles általános jelleggel ellenőrizni a Felhasználói Tartalmat, de jogosult jogsértés, biztonsági kockázat, visszaélés vagy hatósági megkeresés esetén intézkedni."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató jogosult a jogsértő, nyilvánvalóan káros, biztonsági kockázatot jelentő vagy az ÁSZF-et sértő tartalmat eltávolítani, elérhetetlenné tenni, a hozzáférést korlátozni vagy a fiókot felfüggeszteni."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "10. Tiltott használat"
      },
      {
        "type": "paragraph",
        "text": "a Szolgáltatás megzavarása, túlterhelése, feltörése, sebezhetőségeinek kihasználása vagy reverse engineeringje;"
      },
      {
        "type": "paragraph",
        "text": "spam, kéretlen reklám, adathalászat, csalás, kártevő, bot, scraping vagy jogellenes automatizált adatgyűjtés;"
      },
      {
        "type": "paragraph",
        "text": "hivatalos pályázati, hatósági vagy külső rendszerek megkerülése, félrevezetése, jogosulatlan automatizálása vagy terhelése;"
      },
      {
        "type": "paragraph",
        "text": "más személy fiókjának, személyazonosságának vagy jogosultságának jogosulatlan használata;"
      },
      {
        "type": "paragraph",
        "text": "jogellenes, megtévesztő, sértő, zaklató, fenyegető, diszkriminatív vagy mások jogait sértő tartalom kezelése;"
      },
      {
        "type": "paragraph",
        "text": "a Szolgáltatás használata jogszabály, hatósági határozat, pályázati feltétel, szerződés vagy harmadik személy jogának megsértésére;"
      },
      {
        "type": "paragraph",
        "text": "AI-asszisztált vagy exportált tartalom hivatalos, jogi, pénzügyi vagy pályázati szakvéleményként történő feltüntetése ellenőrzés nélkül."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "11. Automatizmusok, szabálymotor, AI-asszisztált funkciók és döntéshozatal"
      },
      {
        "type": "paragraph",
        "text": "11.1. Az Orienta automatikus státuszokat, jogosultsági vagy readiness eredményeket, feladatokat, figyelmeztetéseket és rendszerüzeneteket állíthat elő a Felhasználó beállításai, az Ügyfél által megadott adatok, hivatalos vagy nyilvános források, belső szabályok, ellenőrzött dossziéadatok és alkalmazásesemények alapján."
      },
      {
        "type": "paragraph",
        "text": "11.2. A Szolgáltatás automatikus eredményei döntéstámogatási és előkészítési célúak. Nem minősülnek hivatalos, hatósági, támogatói, jogi, pénzügyi vagy pályázati döntésnek, és önmagukban nem járnak joghatással vagy hasonlóan jelentős hatással az érintettre."
      },
      {
        "type": "paragraph",
        "text": "11.3. Az Orienta alapelve, hogy a végső jogosultsági eredményt determinisztikus szabálymotor vagy manuális felülvizsgálat adja. AI-kimenet önmagában nem lehet végleges jogosultsági döntés."
      },
      {
        "type": "paragraph",
        "text": "11.4. AI-asszisztált funkciók használata esetén az AI összefoglalhat, kivonatolhat, magyarázhat, fogalmazási javaslatot adhat vagy strukturált javaslatot készíthet. Az AI-kimenetek pontatlanok, hiányosak vagy félreérthetők lehetnek, ezért azokat az Ügyfélnek, Felhasználónak vagy megfelelő szakértőnek ellenőriznie kell."
      },
      {
        "type": "paragraph",
        "text": "11.5. Az Ügyfél felel azért, hogy a Szolgáltatásból exportált vagy átvett anyagokat hivatalos beadás, szerződéskötés, pénzügyi döntés vagy jogi állítás előtt ellenőrizze és szükség szerint szakértővel validáltassa."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "12. Adatvédelem és adatfeldolgozói szerepek"
      },
      {
        "type": "paragraph",
        "text": "12.1. A Szolgáltató saját ügyfél-, fiók-, számlázási, fizetési, támogatási, marketing-, biztonsági, jogérvényesítési és szolgáltatásüzemeltetési adatkezelései tekintetében adatkezelő. Ezen adatkezelések részleteit az Orienta Adatkezelési Tájékoztató tartalmazza."
      },
      {
        "type": "paragraph",
        "text": "12.2. Amennyiben az Ügyfél a Szolgáltatásba saját munkavállalói, ügyfelei, partnerei, kapcsolattartói, képviselői vagy más harmadik személyek személyes adatait tölti fel vagy kezeli, az Ügyfél dönt az adatkezelés céljáról és eszközeiről. Ilyen esetben az Ügyfél adatkezelő vagy adatfeldolgozó, a Szolgáltató pedig az Ügyfél nevében adatfeldolgozóként jár el a jelen ÁSZF A. melléklete szerinti Adatfeldolgozási Megállapodás alapján."
      },
      {
        "type": "paragraph",
        "text": "12.3. Az Ügyfél felel azért, hogy a Szolgáltatásba feltöltött személyes adatok jogszerűen kerüljenek kezelésre, az érintettek megfelelő tájékoztatást kapjanak, és az adatkezeléshez szükséges jogalap rendelkezésre álljon."
      },
      {
        "type": "paragraph",
        "text": "12.4. A Szolgáltató adatfeldolgozóként kizárólag az Ügyfél dokumentált utasításai, az ÁSZF, az Adatfeldolgozási Megállapodás, a megrendelés és a jogszabályok szerint jár el."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "13. Harmadik fél szolgáltatások és integrációk"
      },
      {
        "type": "paragraph",
        "text": "13.1. A Szolgáltatás működéséhez és fejlesztéséhez a Szolgáltató külső szolgáltatókat vesz igénybe, különösen infrastruktúra, hosting, backend, auth, e-mail, fizetés, számlázás, AI, analitika, marketing, hirdetés, push értesítés, ügyfélszolgálat és jogi/könyvelési támogatás területén."
      },
      {
        "type": "paragraph",
        "text": "13.2. A Harmadik Fél Szolgáltatások saját feltételei és adatvédelmi dokumentumai is irányadóak lehetnek. A Szolgáltató törekszik arra, hogy megfelelő adatfeldolgozói szerződés, adattovábbítási garancia és biztonsági intézkedés álljon rendelkezésre."
      },
      {
        "type": "paragraph",
        "text": "13.3. Az Orienta adatfeldolgozói és szolgáltatói listáját az Adatkezelési Tájékoztató tartalmazza. A lista szolgáltatásváltozás esetén frissülhet."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "14. Rendelkezésre állás, karbantartás és támogatás"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató törekszik a Szolgáltatás folyamatos és biztonságos elérhetőségére, de nem garantálja a megszakításmentes, hibamentes vagy minden eszközön azonos működést."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató karbantartást, frissítést, biztonsági javítást, adatfeldolgozói változást vagy infrastruktúra-módosítást végezhet. Tervezett, jelentős karbantartásról a Szolgáltató ésszerű időben tájékoztatást ad."
      },
      {
        "type": "paragraph",
        "text": "Ügyfélszolgálat a segitseg@orientaplatform.eu e-mail címen és a https://orientaplatform.eu/kapcsolat/ felületen érhető el. Standard válaszadási idő: legfeljebb 5 munkanap. A támogatási idő munkanapokon 9:00 és 17:00 között értendő."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató külön SLA-t csak egyedi írásbeli megállapodásban vállal."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "15. Adatok exportja, törlése és megszűnés"
      },
      {
        "type": "paragraph",
        "text": "A szerződés fennállása alatt az Ügyfél a Szolgáltatás elérhető funkciói szerint exportálhatja saját adatait, dossziéit, projektbriefjeit, feladatait, csomagjait vagy egyéb támogatott exportformátumait."
      },
      {
        "type": "paragraph",
        "text": "A szerződés megszűnése után a Szolgáltató legalább 30 napig biztosíthat adatmentési vagy exportálási időablakot, kivéve, ha jogszabály, biztonsági ok, díjtartozás, jogvita vagy műszaki korlát ezt kizárja."
      },
      {
        "type": "paragraph",
        "text": "A fiók és a szolgáltatási adatok törlését követően a biztonsági mentésekből történő végleges törlés legfeljebb 180 napot vehet igénybe. Számlázási, számviteli, adózási, biztonsági, audit, forrásproveniencia és jogérvényesítési adatok jogszabály vagy jogos érdek alapján tovább megőrizhetők."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél köteles a megszűnés előtt minden szükséges adatot exportálni. A Szolgáltató nem felel az Ügyfél elmulasztott exportja miatt bekövetkező adatvesztésért, kivéve, ha a felelősség kötelező jogszabály alapján nem zárható ki."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "16. Panaszkezelés, békéltető testület és jogorvoslat"
      },
      {
        "type": "paragraph",
        "text": "16.1. Panasz a panasz@orientaplatform.eu e-mail címen vagy a https://orientaplatform.eu/kapcsolat/ felületen nyújtható be. A Szolgáltató a panaszt kivizsgálja, és a vonatkozó jogszabályok szerint, legkésőbb 30 napon belül válaszol."
      },
      {
        "type": "paragraph",
        "text": "16.2. Fogyasztó panaszával fogyasztóvédelmi hatósághoz vagy békéltető testülethez fordulhat. A Szolgáltató székhelye szerint illetékes békéltető testület: Pest Vármegyei Békéltető Testület, 1119 Budapest, Etele út 59-61. II. em. 240.; levelezési cím: 1364 Budapest, Pf. 81.; e-mail: pmbekelteto@pmkik.hu; telefon: +36 1 269 0703."
      },
      {
        "type": "paragraph",
        "text": "16.3. Az Európai Unió korábbi online vitarendezési platformjára vonatkozó kötelező tájékoztatási modell megszűnt; a fogyasztói jogviták rendezésére a magyar békéltető testületi és hatósági eljárások irányadóak."
      },
      {
        "type": "paragraph",
        "text": "16.4. A felek törekednek vitáikat békés úton rendezni. Ennek eredménytelensége esetén a magyar jog és a hatáskörrel, illetékességgel rendelkező magyar bíróságok irányadóak; fogyasztó esetén a kötelező fogyasztói fórumjogokat ez nem korlátozza."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "17. Közvetítő szolgáltatói és DSA tájékoztatás"
      },
      {
        "type": "paragraph",
        "text": "17.1. Az Orienta annyiban minősülhet tárhelyszolgáltatásnak, amennyiben a Szolgáltató a Felhasználói Tartalmat az Ügyfél vagy a Felhasználó kérésére tárolja. A Szolgáltatás nem minősül nyilvános közösségi platformnak vagy piactérnek."
      },
      {
        "type": "paragraph",
        "text": "17.2. Jogellenes tartalommal, visszaéléssel vagy DSA szerinti bejelentéssel kapcsolatban a dsa@orientaplatform.eu cím használható. A bejelentésben kérjük megadni az érintett tartalom pontos azonosítóját, a jogsértés indokát és az elérhetőséget."
      },
      {
        "type": "paragraph",
        "text": "17.3. A Szolgáltató a bejelentéseket ésszerű időn belül megvizsgálja, és szükség esetén a tartalmat eltávolíthatja, a hozzáférést korlátozhatja, a fiókot felfüggesztheti, illetve hatósági vagy jogi intézkedést kezdeményezhet."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "18. Akadálymentesség és visszajelzés"
      },
      {
        "type": "paragraph",
        "text": "18.1. A Szolgáltató törekszik arra, hogy az Orienta ésszerűen hozzáférhető és használható legyen minél szélesebb felhasználói kör számára. Visszajelzés a segitseg@orientaplatform.eu címen küldhető."
      },
      {
        "type": "paragraph",
        "text": "18.2. Ha valamely funkció használata akadályba ütközik, a Szolgáltató ésszerű keretek között alternatív ügyfélszolgálati segítséget nyújthat."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "19. Szellemi tulajdon"
      },
      {
        "type": "paragraph",
        "text": "Az Orienta, a szoftver, a felület, a márkanév, a dizájn, a dokumentáció, a feldolgozási logika, a forrásfeldolgozási módszertan és a kapcsolódó know-how a Szolgáltató vagy jogosultjai szellemi tulajdona."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél a szerződés időtartamára nem kizárólagos, nem átruházható, visszavonható használati jogot kap a Szolgáltatás rendeltetésszerű használatára."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél és a Felhasználó megtartja a Felhasználói Tartalom feletti jogait. Az Ügyfél a Szolgáltató részére olyan mértékű felhasználási jogot biztosít, amely a Szolgáltatás nyújtásához, tároláshoz, megjelenítéshez, feldolgozáshoz, továbbításhoz, mentéshez, támogatáshoz és biztonsági műveletekhez szükséges."
      },
      {
        "type": "paragraph",
        "text": "A hivatalos vagy nyilvános pályázati források, jogszabályok és harmadik fél dokumentumok a saját jogosultjaikhoz tartoznak. Az Orienta ezekből nem szerez tulajdonjogot; a Szolgáltatás forrásfeldolgozási és hivatkozási célból kezelheti azokat a jogszerű keretek között."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "20. Felelősség"
      },
      {
        "type": "paragraph",
        "text": "20.1. A Szolgáltató felelőssége a kötelező jogszabályi eseteket kivéve nem terjed ki közvetett károkra, elmaradt haszonra, üzleti lehetőség elvesztésére, támogatás vagy pályázati lehetőség elvesztésére, adatvesztésre, reputációs kárra, harmadik fél szolgáltató hibájára, hivatalos forrás változására vagy elérhetetlenségére, valamint az Ügyfél vagy Felhasználó által megadott téves, hiányos vagy jogellenes adatokból eredő károkra."
      },
      {
        "type": "paragraph",
        "text": "20.2. A Szolgáltató nem felel a pályázati, támogatói, hatósági, banki, pénzügyi vagy más külső döntésekért, határidőkért, hiánypótlásokért, elutasításokért, formai követelményekért vagy külső rendszerek működéséért. Az Orienta eredményeit az Ügyfélnek hivatalos beadás előtt ellenőriznie kell."
      },
      {
        "type": "paragraph",
        "text": "20.3. A Szolgáltató nem felel a szolgáltatás olyan hibájáért vagy kimaradásáért, amely külső infrastruktúra, fizetési szolgáltató, e-mail szolgáltató, AI szolgáltató, internetkapcsolat, operációs rendszer, böngésző, hivatalos forrás, hatósági intézkedés, vis maior vagy az Ügyfél rendszere miatt következik be."
      },
      {
        "type": "paragraph",
        "text": "20.4. Fogyasztó esetén a felelősségkorlátozás nem érinti azokat a jogokat és igényeket, amelyekről a Fogyasztó jogszabály alapján nem mondhat le."
      },
      {
        "type": "paragraph",
        "text": "20.5. Vállalkozás vagy szervezet Ügyfél esetén a Szolgáltató szerződéses felelőssége a kár bekövetkezését megelőző 12 hónapban az adott Ügyfél által ténylegesen megfizetett díjak összegére korlátozódik, kivéve a szándékos károkozást, az életet, testi épséget vagy egészséget sértő károkat, valamint azokat az eseteket, ahol a korlátozás jogszabály alapján nem alkalmazható."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "21. Felfüggesztés és megszüntetés"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató jogosult a hozzáférést részben vagy egészben felfüggeszteni, ha fizetési késedelem, biztonsági kockázat, jogsértés, visszaélés, tiltott használat, hatósági megkeresés vagy az ÁSZF súlyos megsértése merül fel."
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél a Szolgáltatásban elérhető lemondási funkcióval vagy az ügyfélszolgálaton keresztül szüntetheti meg az előfizetését."
      },
      {
        "type": "paragraph",
        "text": "Súlyos szerződésszegés esetén a másik fél írásbeli értesítéssel azonnali hatállyal felmondhatja a szerződést, ha a szerződésszegés nem orvosolható vagy a fél az ésszerű határidőn belül nem orvosolja."
      },
      {
        "type": "paragraph",
        "text": "A megszűnés nem érinti a már esedékessé vált díjakat, a jogszabályi megőrzési kötelezettségeket, az adatvédelmi és titoktartási rendelkezéseket, valamint a jogérvényesítési igényeket."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "22. ÁSZF módosítása"
      },
      {
        "type": "paragraph",
        "text": "22.1. A Szolgáltató jogosult az ÁSZF-et módosítani különösen jogszabályváltozás, szolgáltatásváltozás, új funkció, díjcsomag, adatfeldolgozó, AI-funkció, biztonsági ok, üzleti működés vagy hatósági/bírósági gyakorlat változása esetén."
      },
      {
        "type": "paragraph",
        "text": "22.2. A lényeges, az Ügyfelet hátrányosan érintő módosításról a Szolgáltató legalább 15 nappal korábban e-mailben, alkalmazáson belüli üzenetben vagy weboldali tájékoztatóval értesítést ad. Ha az Ügyfél a módosítás hatálybalépése után tovább használja a Szolgáltatást, az a módosított ÁSZF elfogadásának minősül."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "23. Irányadó jog, vegyes rendelkezések"
      },
      {
        "type": "paragraph",
        "text": "23.1. Jelen ÁSZF-re a magyar jog irányadó. A felek jogviszonyára a Polgári Törvénykönyv, az elektronikus kereskedelmi szolgáltatásokra, fogyasztóvédelemre, adatvédelemre, digitális szolgáltatásokra, szerzői jogra és egyéb releváns területekre vonatkozó jogszabályok alkalmazandóak."
      },
      {
        "type": "paragraph",
        "text": "23.2. Ha az ÁSZF valamely rendelkezése érvénytelen vagy hatálytalan, az nem érinti a többi rendelkezés érvényességét."
      },
      {
        "type": "paragraph",
        "text": "23.3. A Szolgáltató elektronikus úton tart kapcsolatot az Ügyféllel és a Felhasználókkal. Az Ügyfél köteles működő e-mail címet fenntartani és értesítéseit figyelni."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "A. melléklet - Adatfeldolgozási Megállapodás"
      },
      {
        "type": "paragraph",
        "text": "Ez a melléklet a GDPR 28. cikke szerinti adatfeldolgozási feltételeket tartalmazza arra az esetre, ha a Szolgáltató az Ügyfél nevében személyes adatokat dolgoz fel az Orienta használata során."
      },
      {
        "type": "heading",
        "level": 3,
        "text": "A.1. Tárgy, időtartam, jelleg és cél"
      },
      {
        "type": "table",
        "rows": [
          [
            "Tárgy",
            "Az Orienta szolgáltatás nyújtása, fiókkezelés, szervezeti jogosultságkezelés, dosszié- és projektadatok tárolása, dokumentum- és bizonyítékkezelés, jogosultsági/readiness eredmények, csomagkészítés, értesítésküldés, támogatás, mentés, helyreállítás, naplózás és kapcsolódó technikai műveletek."
          ],
          [
            "Időtartam",
            "A szerződés időtartama, továbbá a megszűnést követő adatmentési/export időablak, törlési folyamat és jogszabályi megőrzési idő."
          ],
          [
            "Adatkezelés jellege",
            "Gyűjtés, rögzítés, tárolás, rendszerezés, hozzáférés biztosítása, továbbítás, megjelenítés, feldolgozás, elemzés, mentés, helyreállítás, törlés, technikai támogatás és biztonsági naplózás."
          ],
          [
            "Adatkezelés célja",
            "Az Ügyfél által igénybe vett Szolgáltatás teljesítése és az Ügyfél dokumentált utasításainak végrehajtása."
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "text": "A.2. Érintettek és adatkategóriák"
      },
      {
        "type": "table",
        "rows": [
          [
            "Érintetti kör",
            "Adatkategóriák"
          ],
          [
            "Ügyfél Felhasználói",
            "név, e-mail, fiókazonosító, szerepkör, belépési és használati naplók, jogosultságok, beállítások"
          ],
          [
            "Ügyfél munkavállalói, képviselői, kapcsolattartói",
            "név, elérhetőség, szerepkör, képviseleti és aláírási adatok, jogosultsági vagy dokumentumadatok"
          ],
          [
            "Ügyfél ügyfelei, partnerei, tanácsadói vagy beszállítói",
            "az Ügyfél által rögzített név, elérhetőség, szervezeti kapcsolat, projekt- vagy feladatadat, dokumentum, megjegyzés, státusz, időbélyeg"
          ],
          [
            "Kommunikációban szereplő személyek",
            "üzenetek, bejelentések, csatolmányok, státuszok, metaadatok"
          ],
          [
            "Egyéb személyek",
            "az Ügyfél által a Szolgáltatásba jogszerűen bevitt adatok a Szolgáltatás célja szerint"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "text": "A.3. A Szolgáltató adatfeldolgozói kötelezettségei"
      },
      {
        "type": "paragraph",
        "text": "a személyes adatokat kizárólag az Ügyfél dokumentált utasítása, az ÁSZF és a jogszabályok szerint kezeli;"
      },
      {
        "type": "paragraph",
        "text": "biztosítja, hogy a személyes adatokhoz hozzáférő személyek titoktartási kötelezettség alatt álljanak;"
      },
      {
        "type": "paragraph",
        "text": "a kockázathoz igazodó technikai és szervezési biztonsági intézkedéseket alkalmaz;"
      },
      {
        "type": "paragraph",
        "text": "az Ügyfelet lehetőség szerint segíti az érintetti jogok, adatvédelmi incidensek, hatásvizsgálatok és felügyeleti hatósági megkeresések kezelésében;"
      },
      {
        "type": "paragraph",
        "text": "a szerződés megszűnésekor az Ügyfél választása szerint törli vagy visszaadja az adatokat, kivéve, ha jogszabály vagy jogos megőrzési érdek további megőrzést ír elő;"
      },
      {
        "type": "paragraph",
        "text": "az adatfeldolgozói megfelelés igazolásához szükséges ésszerű információkat az Ügyfél rendelkezésére bocsátja."
      },
      {
        "type": "heading",
        "level": 3,
        "text": "A.4. Al-adatfeldolgozók"
      },
      {
        "type": "paragraph",
        "text": "Az Ügyfél általános írásbeli engedélyt ad arra, hogy a Szolgáltató a Szolgáltatás nyújtásához al-adatfeldolgozókat vegyen igénybe. A Szolgáltató az al-adatfeldolgozókkal megfelelő adatvédelmi kötelezettségekkel összeegyeztethető szerződéses feltételeket alkalmaz."
      },
      {
        "type": "table",
        "rows": [
          [
            "Al-adatfeldolgozó",
            "Szolgáltatás",
            "Megjegyzés"
          ],
          [
            "Cloudflare",
            "DNS, CDN, biztonsági forgalomkezelés",
            "EU-USA DPF és SCC/DPA"
          ],
          [
            "Vercel",
            "webalkalmazás hosting, frontend/SSR, edge/CDN, deployment/runtime",
            "globális; DPA, SCC, EU-USA DPF"
          ],
          [
            "Supabase",
            "backend, adatbázis, auth, API",
            "AWS Zurich; support hozzáférés lehetséges"
          ],
          [
            "Supabase Edge Functions",
            "serverless/edge funkciók, webhookok",
            "globális edge; DPA/SCC"
          ],
          [
            "Resend",
            "tranzakciós e-mailek",
            "USA feldolgozás; DPA-ban SCC"
          ],
          [
            "Zoho",
            "tranzakciós e-mail, SMTP/API, logok",
            "EU régió; DPA és SCC"
          ],
          [
            "Brevo",
            "marketing e-mail, hírlevél, kampányok",
            "EU; DPA/SCC/DPF alvállalkozóknál"
          ],
          [
            "WonderPush",
            "push értesítések és SDK",
            "EEA infrastruktúra; SCC ha szükséges"
          ],
          [
            "Google OAuth",
            "Google-fiókkal bejelentkezés",
            "DPF/SCC/Google transfer terms"
          ],
          [
            "Google Gemini / Google AI",
            "opcionális AI-asszisztált magyarázat, összefoglalás vagy kivonatolás",
            "globális; DPF/SCC; csak bekapcsolt funkciónál"
          ],
          [
            "Google Analytics / GTM",
            "analitika, eseménymérés, tag management",
            "DPF/SCC; hozzájárulás-köteles"
          ],
          [
            "Google Ads",
            "hirdetés, remarketing, konverzió",
            "Controller Terms; DPF/SCC"
          ],
          [
            "Google Workspace",
            "céges e-mail, ügyfélszolgálati levelezés",
            "Google Cloud DPA, DPF/SCC"
          ],
          [
            "Stripe",
            "fizetés, előfizetés, fraud/compliance",
            "európai Stripe entitás; DPF/DTA/SCC"
          ],
          [
            "NAV",
            "adószám alapján cégadat-ellenőrzés",
            "Magyarország"
          ],
          [
            "Számlázz.hu / KBOSS.hu Kft.",
            "elektronikus számlázás, NAV adattovábbítás",
            "EU régió"
          ],
          [
            "Taxi-MED Kft.",
            "könyvvitel - 5463 Nagyrév Újtelep út 15.",
            "Magyarország; 13838379-2-16"
          ],
          [
            "K&H Bank Zrt.",
            "fizetés, előfizetés, fraud/compliance",
            "EU régió; megőrzés jogszabály szerint"
          ],
          [
            "Jogi képviselő",
            "Szolgáltató jogi képviselete",
            "Magyarország"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "text": "A.5. Nemzetközi adattovábbítás"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató törekszik EU/EGT-n belüli vagy megfelelőségi határozattal rendelkező országban történő adatkezelésre. Egyes szolgáltatók globális infrastruktúrát, támogatást vagy al-adatfeldolgozókat vesznek igénybe, ezért személyes adatok az EU/EGT-n kívülre is továbbításra kerülhetnek. Ilyen szolgáltató különösen Cloudflare, Vercel, Resend, Google, Stripe, valamint adott beállítástól függően Zoho és Supabase Edge Functions. Ilyen esetben az adattovábbítás GDPR szerinti garanciák alapján történik: megfelelőségi határozat, EU-USA DPF, SCC, DPA és szükség szerinti kiegészítő intézkedések."
      },
      {
        "type": "heading",
        "level": 3,
        "text": "A.6. Ügyfél kötelezettségei"
      },
      {
        "type": "paragraph",
        "text": "az Ügyfél biztosítja, hogy az általa bevitt személyes adatok kezeléséhez megfelelő jogalap és tájékoztatás rendelkezésre álljon;"
      },
      {
        "type": "paragraph",
        "text": "az Ügyfél nem utasíthatja a Szolgáltatót jogellenes adatkezelésre;"
      },
      {
        "type": "paragraph",
        "text": "az Ügyfél köteles a szükségtelen, pontatlan vagy jogellenesen kezelt adatokat törölni vagy javítani;"
      },
      {
        "type": "paragraph",
        "text": "különleges személyes adat feltöltése esetén az Ügyfél felel a külön jogszabályi feltételekért és szükség esetén adatvédelmi hatásvizsgálatért."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "B. melléklet - Elállási nyilatkozat mintája fogyasztók részére"
      },
      {
        "type": "paragraph",
        "text": "A Fogyasztó az alábbi nyilatkozatminta felhasználásával is gyakorolhatja elállási jogát, ha az a szerződésre alkalmazandó jogszabályok szerint fennáll."
      },
      {
        "type": "paragraph",
        "text": "Címzett: Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság, 2013 Pomáz, Rozmaring utca 5.; e-mail: info@orientaplatform.eu"
      },
      {
        "type": "paragraph",
        "text": "Alulírott kijelentem, hogy elállok az Orienta szolgáltatásra vonatkozó szerződésemtől."
      },
      {
        "type": "table",
        "rows": [
          [
            "Megrendelés vagy előfizetés azonosítója",
            "______________________________"
          ],
          [
            "A megrendelés dátuma",
            "______________________________"
          ],
          [
            "A fogyasztó neve",
            "______________________________"
          ],
          [
            "A fogyasztó címe",
            "______________________________"
          ],
          [
            "Dátum",
            "______________________________"
          ],
          [
            "Aláírás (papíron benyújtva)",
            "______________________________"
          ]
        ]
      }
    ]
  },
  {
    "slug": "adatvedelem",
    "path": "/adatvedelem/",
    "label": "Adatvédelem",
    "title": "Adatkezelési Tájékoztató",
    "description": "Az Orienta Adatkezelési Tájékoztatója a weboldal, alkalmazás és kapcsolódó szolgáltatások adatkezeléseiről.",
    "meta": [
      {
        "label": "Utolsó módosítás",
        "value": "2026. június 1."
      },
      {
        "label": "Verzió",
        "value": "1.1"
      },
      {
        "label": "Weboldal",
        "value": "https://orientaplatform.eu"
      },
      {
        "label": "Adatvédelmi kapcsolattartó",
        "value": "adatvedelem@orientaplatform.eu"
      }
    ],
    "blocks": [
      {
        "type": "heading",
        "level": 2,
        "text": "1. Adatkezelő"
      },
      {
        "type": "table",
        "rows": [
          [
            "Adatkezelő",
            "Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság"
          ],
          [
            "Székhely",
            "2013 Pomáz, Rozmaring utca 5."
          ],
          [
            "Levelezési cím",
            "2013 Pomáz, Rozmaring utca 5."
          ],
          [
            "Cégjegyzékszám",
            "13-09-196494"
          ],
          [
            "Adószám",
            "26581840-2-13"
          ],
          [
            "Képviselő",
            "Édes Gábor"
          ],
          [
            "E-mail",
            "info@orientaplatform.eu"
          ],
          [
            "Telefon",
            "+36 70 607 2310"
          ],
          [
            "Weboldal",
            "https://orientaplatform.eu"
          ],
          [
            "Adatvédelmi kapcsolattartó",
            "Édes Gábor, adatvedelem@orientaplatform.eu"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "2. A Tájékoztató hatálya és az Orienta működése"
      },
      {
        "type": "paragraph",
        "text": "A jelen Tájékoztató az Orienta weboldal, alkalmazás, fiók, előfizetés, ügyfélszolgálat, fizetés, számlázás, marketing, analitika, hirdetés, push értesítés és kapcsolódó szolgáltatások adatkezeléseire vonatkozik."
      },
      {
        "type": "paragraph",
        "text": "Az Orienta fő funkciói: regisztráció és fiókkezelés; szervezeti dosszié és projektbrief kezelése; pályázati lehetőségek keresése és jogosultsági előszűrése; feladatlista, státuszkezelés és riportok; dokumentumok, képek vagy csatolmányok feltöltése; adminisztrátori jogosultságok."
      },
      {
        "type": "paragraph",
        "text": "Ha az Ügyfél a Szolgáltatásba saját munkavállalói, ügyfelei, partnerei vagy más személyek adatait tölti fel, akkor ezen adatok tekintetében az Ügyfél határozza meg az adatkezelés célját és jogalapját. Ilyenkor az Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság főszabály szerint adatfeldolgozóként jár el az Ügyfél nevében, az ÁSZF adatfeldolgozási melléklete szerint."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "3. Alapelvek"
      },
      {
        "type": "paragraph",
        "text": "csak meghatározott, egyértelmű és jogszerű célból kezelünk adatot;"
      },
      {
        "type": "paragraph",
        "text": "csak a szükséges adatokat kezeljük (adatminimalizálás);"
      },
      {
        "type": "paragraph",
        "text": "törekszünk az adatok pontosságára és naprakészségére;"
      },
      {
        "type": "paragraph",
        "text": "az adatokat csak a szükséges ideig őrizzük meg;"
      },
      {
        "type": "paragraph",
        "text": "a kockázatokhoz igazodó technikai és szervezési biztonsági intézkedéseket alkalmazunk;"
      },
      {
        "type": "paragraph",
        "text": "az érintettek jogainak gyakorlását támogatjuk és elősegítjük."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "4. Adatok forrása"
      },
      {
        "type": "paragraph",
        "text": "Személyes adat származhat közvetlenül Öntől, az Ügyféltől vagy szervezeti adminisztrátortól, az Orienta használatából, technikai naplókból, fizetési és számlázási szolgáltatóktól, Google-bejelentkezésből, NAV cégadat-lekérdezésből, valamint marketing vagy ügyfélszolgálati kommunikációból."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "5. Adatkezelési célok, jogalapok és megőrzési idők"
      },
      {
        "type": "paragraph",
        "text": "Az alábbi táblázat összefoglalja az adatkezelési célokat, kezelt adatokat, jogalapokat, megőrzési időket és az érintett adatfeldolgozókat."
      },
      {
        "type": "table",
        "rows": [
          [
            "Cél",
            "Kezelt adatok",
            "Jogalap",
            "Megőrzés",
            "Adatfeldolgozók"
          ],
          [
            "Weboldal, app és technikai működés",
            "IP-cím, böngésző/eszköz adatok, naplók, session- és biztonsági azonosítók",
            "szerződés teljesítése; jogos érdek a biztonságos működéshez; feltétlenül szükséges tech-nél ePrivacy kivétel",
            "munkamenet ideje; tech/biztonsági logok 30-180 nap; incidens esetén max. 5 év",
            "Cloudflare, Vercel, Supabase, AWS"
          ],
          [
            "Regisztráció, bejelentkezés, fiók",
            "név, e-mail, jelszó hash, auth azonosítók, fiókazonosító, szerepkör, jogosultság",
            "szerződés teljesítése; biztonsági jogos érdek",
            "fiók fennállása alatt; törlés után max. 180 nap; jogérvényesítési adatok 5 év",
            "Supabase Auth, Google OAuth"
          ],
          [
            "Dosszié, projektadatok, feladatok, dokumentumok kezelése",
            "szervezeti és projektadatok, jogosultsági előszűréshez kapcsolódó adatok, feladatok, határidők, státuszok, dokumentumok, képek, csatolmányok, metaadatok",
            "szerződés teljesítése; harmadik személyes adatoknál Szolgáltató adatfeldolgozó",
            "fiók fennállásáig; megszűnés után min. 30 nap export ablak; mentések max. 180 nap",
            "Supabase, Cloudflare, Vercel, Edge Functions"
          ],
          [
            "Értesítések, tranzakciós e-mailek",
            "e-mail, név, értesítési beállítás, levéltartalom, kézbesítési státusz",
            "szerződés teljesítése; jogos érdek",
            "fiók fennállása alatt; kézbesítési naplók 30-180 nap; jogvita esetén 5 év",
            "Resend, Zoho, Google Workspace"
          ],
          [
            "Push értesítések (ha élesítve)",
            "push token, eszközazonosító, user ID, eszköztípus, értesítési beállítás",
            "szerződéses push: szerződés/jogos érdek; marketing push: hozzájárulás",
            "push engedély vagy fiók fennállásáig; visszavonás után azonnali token törlés",
            "WonderPush, Apple/Google push"
          ],
          [
            "Fizetés, előfizetés, számlázás",
            "név, e-mail, számlázási cím, adószám, csomag, díj, Stripe ID, számlaadatok",
            "szerződés teljesítése; jogi kötelezettség számlázásnál; jogos érdek csalásmegelőzésnél",
            "számviteli bizonylatok 8 év; szerződéses adatok 5 év; kártyaadatot nem tárolunk",
            "Stripe, Számlázz.hu, NAV, Taxi-MED Kft."
          ],
          [
            "NAV cégadat-lekérdezés adószám alapján",
            "adószám, cégnév, székhely, kapcsolódó cégadat",
            "szerződés teljesítése; számlázási kötelezettség; jogos érdek az adatpontossághoz",
            "számlázási adatokkal együtt 8 év",
            "NAV cégadatforrás"
          ],
          [
            "Ügyfélszolgálat, panaszkezelés",
            "név, e-mail, telefon, üzenet, csatolmány, panasz adatai",
            "szerződés teljesítése; jogos érdek; fogyasztói panaszoknál jogi kötelezettség",
            "ügyek 1-5 év; fogyasztói panaszok jogszabály szerint (jellemzően 3 év)",
            "Google Workspace, jogi képviselő"
          ],
          [
            "Analitika és termékfejlesztés",
            "cookie/client ID, IP, eszközadat, események, oldalhasználati adatok",
            "hozzájárulás, ha nem feltétlenül szükséges; aggregált adatoknál jogos érdek",
            "GA beállítástól függően max. 14 hónap; aggregált statisztika személyazonosításra alkalmatlan formában hosszabb ideig",
            "Google Analytics, GTM"
          ],
          [
            "Marketing, hírlevél",
            "név, e-mail, hozzájárulási státusz, kampányaktivitás, leiratkozás",
            "hozzájárulás; meglévő ügyfélnél feltételek szerint soft opt-in",
            "leiratkozásig; hozzájárulás bizonyítéka 5 év",
            "Brevo"
          ],
          [
            "Google Ads, remarketing",
            "online azonosítók, cookie/device ID, konverziós esemény, kampányadat",
            "marketing hozzájárulás",
            "hozzájárulás visszavonásáig; kampányriportok aggregáltan",
            "Google Ads, GTM"
          ],
          [
            "Jogérvényesítés, DSA, hatósági megkeresés",
            "fiókadatok, naplók, bejelentés, bizonyítékok, hatósági iratok",
            "jogos érdek; jogi kötelezettség",
            "igény elévüléséig, max. 5 év (kivéve hosszabb kötelező idő)",
            "hatóságok, bíróságok, jogi képviselő"
          ],
          [
            "Érintetti kérelmek, adatvédelmi panaszok",
            "kérelem, azonosításhoz szükséges adatok, válasz, határidők",
            "jogi kötelezettség; jogos érdek az elszámoltathatósághoz",
            "kérelem lezárásától számított 5 év",
            "NAIH, jogi képviselő"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "6. Különleges adatok, eszközengedélyek és kiskorúak"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltatás alapértelmezés szerint nem kér és nem kíván kezelni különleges személyes adatot, például egészségügyi adatot, biometrikus adatot, vallási vagy politikai véleményre utaló adatot. Kérjük, ilyen adatot csak akkor töltsön fel, ha ehhez megfelelő jogalappal rendelkezik, és az adott célhoz valóban szükséges."
      },
      {
        "type": "paragraph",
        "text": "Fájlokhoz, fotókhoz, kamerához vagy push értesítéshez való hozzáférés csak az Ön külön művelete vagy eszközengedélye alapján történik, és csak az adott funkció céljára használható. Az operációs rendszerben megadott engedélyeket bármikor módosíthatja."
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltatás kifejezetten nem 16 év alatti személyeknek szól, és 16 év alatti személy önállóan nem regisztrálhat. Ha szervezeti Ügyfél 16 év alatti személy adatát kezeli az Orientában, az Ügyfél felel a megfelelő jogalapért és tájékoztatásért."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "7. Címzettek, adatfeldolgozók és szolgáltatók"
      },
      {
        "type": "table",
        "rows": [
          [
            "Szolgáltató",
            "Cél",
            "Szerep",
            "Adatkör",
            "Régió / garancia"
          ],
          [
            "Cloudflare",
            "DNS, CDN, biztonsági forgalom",
            "adatfeldolgozó / önálló adatkezelő (saját)",
            "IP, DNS/HTTP forgalom, security logok",
            "globális; EU-USA DPF és SCC/DPA"
          ],
          [
            "Vercel",
            "webalkalmazás hosting, frontend/SSR, edge/CDN, deployment",
            "adatfeldolgozó / önálló adatkezelő (saját)",
            "IP, HTTP forgalom, request/log metaadatok, technikai naplók, app request adatok",
            "globális; DPA, SCC, EU-USA DPF"
          ],
          [
            "Supabase",
            "backend, adatbázis, auth, API",
            "adatfeldolgozó",
            "felhasználói azonosítók, e-mail, auth adatok, appadatok",
            "AWS Zurich, Svájc; DPA"
          ],
          [
            "Supabase Edge Functions",
            "serverless/edge, webhookok",
            "adatfeldolgozó",
            "user ID, e-mail, token, tranzakciós adat",
            "globális edge; DPA/SCC"
          ],
          [
            "Resend",
            "tranzakciós e-mailek",
            "adatfeldolgozó",
            "e-mail cím, levéltartalom, delivery metaadatok",
            "USA; DPA-ban SCC"
          ],
          [
            "Zoho",
            "tranzakciós e-mail, SMTP/API",
            "adatfeldolgozó",
            "e-mail, levéltartalom, SMTP log",
            "EU; DPA és SCC"
          ],
          [
            "Brevo",
            "marketing e-mail, hírlevél",
            "adatfeldolgozó",
            "e-mail, lista tagság, kampányaktivitás",
            "EU; DPA/SCC/DPF"
          ],
          [
            "WonderPush",
            "push értesítések",
            "adatfeldolgozó",
            "push token, device ID, user ID",
            "EEA; DPA/SCC"
          ],
          [
            "Google OAuth",
            "Google-bejelentkezés",
            "vegyes",
            "Google subject ID, e-mail, név",
            "globális; DPF/SCC"
          ],
          [
            "Google Analytics / GTM",
            "analitika, tag management",
            "adatfeldolgozó",
            "cookie ID, IP, eseményadatok",
            "globális; DPF/SCC; hozzájárulás-köteles"
          ],
          [
            "Google Ads",
            "hirdetés, remarketing",
            "vegyes controller",
            "online azonosítók, konverziós esemény",
            "globális; Controller Terms, DPF/SCC"
          ],
          [
            "Google Workspace",
            "céges e-mail, ügyfélszolgálat",
            "adatfeldolgozó",
            "e-mail, üzenettartalom, melléklet",
            "globális; Google Cloud DPA, DPF/SCC"
          ],
          [
            "Stripe",
            "fizetés, előfizetés",
            "vegyes",
            "számlázási adatok, Stripe ID, tranzakciós adatok",
            "európai entitás; DPF/DTA/SCC"
          ],
          [
            "NAV",
            "cégadat-ellenőrzés",
            "hatósági forrás",
            "cégnév, székhely, adószám",
            "Magyarország"
          ],
          [
            "Számlázz.hu / KBOSS.hu",
            "elektronikus számlázás",
            "számlázási szolgáltató",
            "számlázási adatok",
            "EU; számviteli megőrzés"
          ],
          [
            "Taxi-MED Kft.",
            "könyvvitel - 5463 Nagyrév Újtelep út 15.",
            "adatfeldolgozó",
            "számlázási adatok, könyvelési iratok",
            "Magyarország; 13838379-2-16"
          ],
          [
            "K&H Bank Zrt.",
            "fizetés, fraud/compliance",
            "vegyes",
            "számlázási, tranzakciós adatok",
            "EU; megőrzés jogszabály szerint"
          ],
          [
            "Jogi képviselő",
            "jogi képviselet",
            "vegyes",
            "szükséges adatok",
            "Magyarország"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "8. Harmadik országba történő adattovábbítás"
      },
      {
        "type": "paragraph",
        "text": "A Szolgáltató törekszik EU/EGT-n belüli vagy megfelelőségi határozattal rendelkező országban történő adatkezelésre. A Supabase projekt/adatbázis régiója Svájc (AWS Zurich); Svájc az Európai Bizottság megfelelőségi határozata alatt áll. Ez ugyanakkor nem jelenti azt, hogy minden szolgáltatói hozzáférés kizárólag Svájcban történik."
      },
      {
        "type": "paragraph",
        "text": "Egyes szolgáltatók globális infrastruktúrát, támogatást vagy al-adatfeldolgozókat vesznek igénybe, így személyes adatok az EU/EGT-n kívülre is továbbításra kerülhetnek. Ilyen szolgáltató különösen Cloudflare, Vercel, Resend, Google, Stripe, valamint adott beállítástól függően Zoho és Supabase Edge Functions."
      },
      {
        "type": "paragraph",
        "text": "Harmadik országba továbbítás akkor történik, ha a GDPR V. fejezete szerinti megfelelő mechanizmus rendelkezésre áll: megfelelőségi határozat, EU-USA Data Privacy Framework, általános szerződési feltételek (SCC), adatfeldolgozói szerződés és szükség szerinti kiegészítő technikai és szervezési intézkedések."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "9. Cookie-k, SDK-k és hasonló technológiák"
      },
      {
        "type": "paragraph",
        "text": "Az Orienta weboldal és app cookie-kat, localStorage/sessionStorage elemeket, SDK-kat, pixeleket, eszközazonosítókat, push tokeneket és hasonló technológiákat használhat."
      },
      {
        "type": "paragraph",
        "text": "Feltétlenül szükséges technológiák: a szolgáltatás működéséhez, belépéshez, biztonsághoz, consent-beállítás tárolásához vagy fizetéshez szükségesek - ezekhez hozzájárulás nem szükséges."
      },
      {
        "type": "paragraph",
        "text": "Nem szükséges technológiák: analitika (Google Analytics), marketing (Google Ads, remarketing), e-mail tracking (Brevo) - ezek csak megfelelő hozzájárulás alapján aktiválódhatnak."
      },
      {
        "type": "paragraph",
        "text": "Cookie-beállításait a weboldal cookie-kezelő felületén, vagy az alkalmazás beállításaiban módosíthatja vagy visszavonhatja. A hozzájárulás visszavonása nem érinti a visszavonás előtti kezelés jogszerűségét."
      },
      {
        "type": "table",
        "rows": [
          [
            "ℹ A részletes cookie-kategóriák, élettartamok és kezelők a Cookie és SDK Tájékoztatóban szerepelnek, amely a weboldalon érhető el."
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "10. Adatbiztonság"
      },
      {
        "type": "paragraph",
        "text": "hozzáférések szerepkör szerinti korlátozása és naplózása;"
      },
      {
        "type": "paragraph",
        "text": "jelszavak biztonságos, nem visszafejthető tárolása (hash);"
      },
      {
        "type": "paragraph",
        "text": "átvitel közbeni titkosítás (HTTPS/TLS);"
      },
      {
        "type": "paragraph",
        "text": "dokumentum- és képfeltöltések titkosított tárolása;"
      },
      {
        "type": "paragraph",
        "text": "rendszeres mentések és helyreállítási eljárások;"
      },
      {
        "type": "paragraph",
        "text": "biztonsági frissítések és sérülékenység-kezelés;"
      },
      {
        "type": "paragraph",
        "text": "adatfeldolgozói szerződések, DPA-k, SCC-k nyilvántartása;"
      },
      {
        "type": "paragraph",
        "text": "adatvédelmi incidensek belső nyilvántartása és szükség esetén hatósági/érintetti bejelentése a jogszabályi határidőkön belül."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "11. Adatmegőrzés, export és törlés"
      },
      {
        "type": "paragraph",
        "text": "Az adatokat csak addig őrizzük meg, ameddig az adott cél teljesítéséhez szükséges, vagy ameddig jogszabály, szerződéses jog, jogérvényesítési érdek vagy biztonsági ok megőrzést indokol. A célonkénti irányadó idők az 5. pontban szerepelnek."
      },
      {
        "type": "paragraph",
        "text": "Fióktörlés vagy szerződés megszűnése esetén az aktív szolgáltatási adatokat töröljük vagy anonimizáljuk, kivéve a számlázási, számviteli, adózási, jogérvényesítési, biztonsági vagy panaszkezelési okból tovább megőrzendő adatokat. A biztonsági mentésekből történő végleges törlés legfeljebb 180 napot vehet igénybe."
      },
      {
        "type": "paragraph",
        "text": "A szerződés megszűnése után az Ügyfél számára legalább 30 napos exportálási időablak biztosítható, kivéve, ha jogszabály, biztonsági ok, jogvita, díjtartozás vagy technikai korlát ezt kizárja."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "12. Automatizált döntéshozatal és profilalkotás"
      },
      {
        "type": "paragraph",
        "text": "Az Orienta státuszváltozásokat, jogosultsági előszűrési eredményeket, feladatokat, emlékeztetőket és rendszerüzeneteket automatizáltan küldhet a felhasználói beállítások, megadott adatok, határidők, feladatok és események alapján. Ezek nem minősülnek olyan kizárólag automatizált döntéshozatalnak, amely joghatással vagy hasonlóan jelentős hatással járna az érintettre."
      },
      {
        "type": "paragraph",
        "text": "Marketing, remarketing és analitika esetén profilalkotási jellegű online azonosító-kezelés előfordulhat, de csak a vonatkozó hozzájárulási és cookie/SDK szabályok szerint. Ön tiltakozhat a direkt marketing ellen, illetve visszavonhatja hozzájárulását."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "13. Érintetti jogok"
      },
      {
        "type": "paragraph",
        "text": "tájékoztatáshoz és hozzáféréshez való jog (GDPR 13-15. cikk);"
      },
      {
        "type": "paragraph",
        "text": "helyesbítéshez való jog (GDPR 16. cikk);"
      },
      {
        "type": "paragraph",
        "text": "törléshez való jog - \"elfeledtetéshez való jog\" (GDPR 17. cikk);"
      },
      {
        "type": "paragraph",
        "text": "adatkezelés korlátozásához való jog (GDPR 18. cikk);"
      },
      {
        "type": "paragraph",
        "text": "adathordozhatósághoz való jog (GDPR 20. cikk);"
      },
      {
        "type": "paragraph",
        "text": "tiltakozáshoz való jog jogos érdeken alapuló adatkezelésnél és direkt marketingnél (GDPR 21. cikk);"
      },
      {
        "type": "paragraph",
        "text": "hozzájárulás visszavonásának joga - a visszavonás nem érinti a visszavonás előtti kezelés jogszerűségét;"
      },
      {
        "type": "paragraph",
        "text": "automatizált döntéshozatallal kapcsolatos jogok, ha ilyen adatkezelés érintené Önt (GDPR 22. cikk)."
      },
      {
        "type": "paragraph",
        "text": "Kérelmét az adatvedelem@orientaplatform.eu e-mail címen nyújthatja be. A kérelem beérkezéséről haladéktalanul visszaigazolást küldünk. Érdemi választ indokolatlan késedelem nélkül, de legkésőbb a beérkezéstől számított 1 hónapon belül adunk. Szükség esetén ez a határidő további 2 hónappal meghosszabbítható; erről a kérelem kézhezvételétől számított 1 hónapon belül tájékoztatjuk."
      },
      {
        "type": "paragraph",
        "text": "A joggyakorlás főszabály szerint ingyenes. Ha a kérelem egyértelműen megalapozatlan, túlzó vagy ismétlődő, ésszerű díjat számíthatunk fel vagy megtagadhatjuk a kérelem teljesítését. A kérelem teljesítése előtt szükség esetén azonosítást kérhetünk."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "14. Panasz és jogorvoslat"
      },
      {
        "type": "paragraph",
        "text": "Ha úgy gondolja, hogy személyes adatainak kezelése sérti az adatvédelmi szabályokat, elsőként javasoljuk, hogy vegye fel velünk a kapcsolatot az adatvedelem@orientaplatform.eu e-mail címen."
      },
      {
        "type": "paragraph",
        "text": "Ön panasszal fordulhat a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (NAIH): e-mail ugyfelszolgalat@naih.hu; levelezési cím 1363 Budapest, Pf. 9.; cím 1055 Budapest, Falk Miksa utca 9-11.; telefon +36 30 683 5969."
      },
      {
        "type": "paragraph",
        "text": "Ön bírósághoz is fordulhat. A pert az Adatkezelővel szemben az Adatkezelő székhelye szerint illetékes törvényszék előtt, vagy választása szerint az Ön lakóhelye vagy tartózkodási helye szerinti törvényszék előtt is megindíthatja."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "15. Adatvédelmi incidensek"
      },
      {
        "type": "paragraph",
        "text": "Adatvédelmi incidens esetén az Adatkezelő belső eljárás alapján haladéktalanul megvizsgálja az esetet és dokumentálja. Ha az incidens valószínűsíthetően kockázattal jár az érintettek jogaira és szabadságaira, az Adatkezelő az incidens észlelésétől számított 72 órán belül bejelenti a NAIH-nak (ugyfelszolgalat@naih.hu)."
      },
      {
        "type": "paragraph",
        "text": "Ha az incidens valószínűsíthetően magas kockázattal jár az érintettek jogaira és szabadságaira, az érintetteket is indokolatlan késedelem nélkül tájékoztatjuk az incidensről, annak jellegéről, várható következményeiről és a meghozott intézkedésekről."
      },
      {
        "type": "table",
        "rows": [
          [
            "ℹ A 72 órás bejelentési határidő az incidens észlelésétől számít. Ha a bejelentés határidőn belül nem lehetséges, indokolással együtt kell megtenni, és az információkat szakaszosan kell közölni."
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "16. A Tájékoztató módosítása"
      },
      {
        "type": "paragraph",
        "text": "A Tájékoztató módosulhat jogszabályváltozás, szolgáltatásváltozás, új adatfeldolgozó, új adatkezelési cél, új cookie/SDK, új integráció vagy biztonsági/jogi ok miatt. A lényeges változásokról a weboldalon, az alkalmazásban vagy e-mailben tájékoztatást adunk legalább 15 nappal a hatályba lépés előtt."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "17. Jogszabályi háttér"
      },
      {
        "type": "paragraph",
        "text": "az Európai Parlament és a Tanács 2016/679/EU rendelete (GDPR);"
      },
      {
        "type": "paragraph",
        "text": "2011. évi CXII. törvény az információs önrendelkezési jogról és az információszabadságról (Infotv.);"
      },
      {
        "type": "paragraph",
        "text": "2001. évi CVIII. törvény az elektronikus kereskedelmi szolgáltatásokról (Ekertv.);"
      },
      {
        "type": "paragraph",
        "text": "2003. évi C. törvény az elektronikus hírközlésről (Eht.) - különösen a végberendezésen történő adattárolás és hozzáférés szabályai;"
      },
      {
        "type": "paragraph",
        "text": "2008. évi XLVIII. törvény a gazdasági reklámtevékenységről (Grtv.);"
      },
      {
        "type": "paragraph",
        "text": "2000. évi C. törvény a számvitelről (Számv. tv.) - 8 éves megőrzési kötelezettség;"
      },
      {
        "type": "paragraph",
        "text": "2013. évi V. törvény a Polgári Törvénykönyvről (Ptk.);"
      },
      {
        "type": "paragraph",
        "text": "az Európai Unió digitális szolgáltatásokról szóló rendelete (DSA), ha és amennyiben a szolgáltatás adott funkciója közvetítő szolgáltatásnak minősül."
      }
    ]
  },
  {
    "slug": "sutik",
    "path": "/sutik/",
    "label": "Sütik",
    "title": "Cookie és SDK Tájékoztató",
    "description": "Az Orienta Cookie és SDK Tájékoztatója a weboldalon és alkalmazásban használt technológiákról.",
    "meta": [
      {
        "label": "Utolsó módosítás",
        "value": "2026. június 1."
      },
      {
        "label": "Verzió",
        "value": "1.1"
      },
      {
        "label": "Weboldal",
        "value": "https://orientaplatform.eu"
      },
      {
        "label": "Adatvédelmi kapcsolattartó",
        "value": "adatvedelem@orientaplatform.eu"
      },
      {
        "label": "Adatkezelő",
        "value": "Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság"
      }
    ],
    "blocks": [
      {
        "type": "heading",
        "level": 2,
        "text": "1. Bevezetés"
      },
      {
        "type": "paragraph",
        "text": "Ez a tájékoztató részletezi, hogy az Orienta weboldal (orientaplatform.eu) és alkalmazás milyen cookie-kat, SDK-kat, helyi tárolókat (localStorage, sessionStorage), pixeleket és hasonló technológiákat használ, ezek milyen célra és mennyi ideig tárolnak adatot, és hogy melyek igényelnek az Ön hozzájárulását."
      },
      {
        "type": "paragraph",
        "text": "A tájékoztató az Adatkezelési Tájékoztató és az ÁSZF kiegészítő melléklete. Az adatkezelés jogalapjaira, az érintetti jogokra és a panaszkezelésre az Adatkezelési Tájékoztató rendelkezései irányadóak."
      },
      {
        "type": "paragraph",
        "text": "Jogszabályi alap: a 2003. évi C. törvény az elektronikus hírközlésről (Eht.) 155. § és az EU ePrivacy irányelv implementációja; a GDPR 6. cikk (1) bekezdés a) pontja (hozzájárulás) és f) pontja (jogos érdek) a szükséges technológiáknál."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "2. Cookie-kategóriák"
      },
      {
        "type": "paragraph",
        "text": "Az Orienta által használt technológiákat az alábbi négy kategóriába soroljuk:"
      },
      {
        "type": "table",
        "rows": [
          [
            "#",
            "Kategória"
          ],
          [
            "1",
            "Feltétlenül szükséges - hozzájárulás nélkül aktiválódnak. A szolgáltatás biztonságos működéséhez, bejelentkezéshez, hitelesítéshez, CSRF-védelemhez és fizetéshez nélkülözhetetlenek. Ezeket nem lehet kikapcsolni."
          ],
          [
            "2",
            "Funkcionális - preferencia-cookie-k, például nyelv- és témavonatkozású beállítások. Az Ön kényelme érdekében tárolják a választásait. Letilthatók, de egyes UI-funkciók nem fognak megfelelően működni."
          ],
          [
            "3",
            "Analitikai - anonimizált vagy pseudonimizált látogatói statisztikák gyűjtése a termékfejlesztéshez. Hozzájárulást igényelnek, ha egyedi azonosítókat alkalmaznak."
          ],
          [
            "4",
            "Marketing és remarketing - hirdetésmérés, konverziókövetés, célzott hirdetések. Minden esetben hozzájárulást igényelnek. Letilthatók a hozzájárulás-kezelő felületen."
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "3. Feltétlenül szükséges cookie-k és technológiák"
      },
      {
        "type": "paragraph",
        "text": "Ezekhez nem szükséges hozzájárulás az Eht. 155. § (4) bekezdés b) pontja alapján, mivel az elektronikus hírközlő hálózat útján történő kommunikáció kizárólagos céljából szükségesek, vagy az információs társadalommal összefüggő szolgáltatás nyújtásához elengedhetetlenül szükségesek."
      },
      {
        "type": "table",
        "rows": [
          [
            "Cookie / technológia neve",
            "Szolgáltató",
            "Cél",
            "Élettartam",
            "Típus"
          ],
          [
            "__cf_bm",
            "Cloudflare",
            "Bot-védelem és biztonsági ellenőrzés",
            "30 perc",
            "HTTP cookie"
          ],
          [
            "cf_clearance",
            "Cloudflare",
            "Sikeres bot-ellenőrzés igazolása",
            "1 nap",
            "HTTP cookie"
          ],
          [
            "_cfuvid",
            "Cloudflare",
            "Cloudflare rate limiting és munkamenet",
            "Munkamenet",
            "HTTP cookie"
          ],
          [
            "Vercel Edge / Runtime technikai naplók",
            "Vercel",
            "Webalkalmazás kiszolgálása, edge/CDN, hibakeresés és biztonságos működés",
            "naplók beállítás szerint",
            "szerveroldali technológia"
          ],
          [
            "sb-[projekt]-auth-token",
            "Supabase",
            "Felhasználói hitelesítési token",
            "Munkamenet / 1 hét",
            "localStorage / cookie"
          ],
          [
            "sb-[projekt]-auth-token-code-verifier",
            "Supabase",
            "OAuth PKCE flow biztonsági elem",
            "Munkamenet",
            "localStorage"
          ],
          [
            "consent_state",
            "Saját",
            "Cookie-hozzájárulás tárolása",
            "1 év",
            "localStorage"
          ],
          [
            "XSRF-TOKEN / csrf_token",
            "Saját",
            "CSRF-védelem",
            "Munkamenet",
            "HTTP cookie"
          ],
          [
            "stripe_mid",
            "Stripe",
            "Fizetési munkamenet azonosítása",
            "1 év",
            "HTTP cookie"
          ],
          [
            "stripe_sid",
            "Stripe",
            "Stripe munkamenet-azonosító",
            "30 perc",
            "HTTP cookie"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "4. Funkcionális cookie-k"
      },
      {
        "type": "paragraph",
        "text": "Ezek a cookie-k az Ön preferenciáit tárolják (pl. nyelv, témavonatkozású beállítások, felhasználói felület állapota). Hozzájárulás szükséges, ha nem kizárólag a Felhasználó által kifejezetten kért szolgáltatáshoz szükségesek. Letiltásuk esetén egyes beállítások munkamenetenként elveszhetnek."
      },
      {
        "type": "table",
        "rows": [
          [
            "Cookie / technológia neve",
            "Szolgáltató",
            "Cél",
            "Élettartam",
            "Típus"
          ],
          [
            "i18n_lang / locale",
            "Saját",
            "Választott nyelv és lokalizáció tárolása",
            "1 év",
            "localStorage / cookie"
          ],
          [
            "ui_theme",
            "Saját",
            "Választott téma (világos/sötét) tárolása",
            "1 év",
            "localStorage"
          ],
          [
            "sidebar_state",
            "Saját",
            "UI beállítások megőrzése",
            "1 év",
            "localStorage"
          ],
          [
            "G_AUTHUSER_H",
            "Google OAuth",
            "Google-bejelentkezési munkamenet",
            "Munkamenet",
            "HTTP cookie"
          ],
          [
            "G_ENABLED_IDPS",
            "Google OAuth",
            "Engedélyezett Google Identity Platform",
            "Munkamenet",
            "HTTP cookie"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "5. Analitikai cookie-k és technológiák"
      },
      {
        "type": "paragraph",
        "text": "Az analitikai technológiák a weboldal és alkalmazás használatát mérik, hogy megértsük, hogyan használják látogatóink az Orientát. Az adatok aggregáltan vagy pseudonimizáltan kerülnek feldolgozásra. Hozzájárulást igényelnek, ha egyedi azonosítókat alkalmaznak."
      },
      {
        "type": "paragraph",
        "text": "IP-cím anonimizálás: a Google Analytics 4 alapértelmezetten anonimizálja az IP-cím utolsó oktetjét az EU-régióban."
      },
      {
        "type": "table",
        "rows": [
          [
            "Cookie / technológia neve",
            "Szolgáltató",
            "Cél",
            "Élettartam",
            "Típus"
          ],
          [
            "_ga",
            "Google Analytics 4",
            "Egyedi látogatói azonosító (client ID)",
            "2 év",
            "HTTP cookie"
          ],
          [
            "_ga_[MÉRÉSI_AZONOSÍTÓ]",
            "Google Analytics 4",
            "Munkamenet-állapot és eseményadatok",
            "2 év",
            "HTTP cookie"
          ],
          [
            "_gid",
            "Google Analytics",
            "Egyedi látogatói azonosító (napi)",
            "24 óra",
            "HTTP cookie"
          ],
          [
            "_gat / _gat_UA-*",
            "Google Analytics",
            "Kérések számának korlátozása (throttling)",
            "1 perc",
            "HTTP cookie"
          ],
          [
            "_clck",
            "Microsoft Clarity (ha aktív)",
            "Felhasználói munkamenet azonosítása",
            "1 év",
            "HTTP cookie"
          ],
          [
            "_clsk",
            "Microsoft Clarity (ha aktív)",
            "Munkamenet-összekapcsolás",
            "1 nap",
            "HTTP cookie"
          ],
          [
            "wp_dataLayer (WonderPush)",
            "WonderPush",
            "Push értesítési SDK belső állapot",
            "Munkamenet",
            "localStorage"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "6. Marketing, remarketing és konverziókövetési cookie-k"
      },
      {
        "type": "paragraph",
        "text": "Ezek a technológiák a hirdetési kampányok hatékonyságának mérésére, remarketing listák összeállítására és célzott hirdetések megjelenítésére szolgálnak. Minden esetben az Ön előzetes hozzájárulása szükséges. Hozzájárulása bármikor visszavonható."
      },
      {
        "type": "table",
        "rows": [
          [
            "Cookie / technológia neve",
            "Szolgáltató",
            "Cél",
            "Élettartam",
            "Típus"
          ],
          [
            "_gcl_au",
            "Google Ads / GTM",
            "Konverziókövetés (AdSense / Ads)",
            "3 hónap",
            "HTTP cookie"
          ],
          [
            "_gcl_aw",
            "Google Ads",
            "Kattintásos konverziókövetés (gclid)",
            "90 nap",
            "HTTP cookie"
          ],
          [
            "_gcl_dc",
            "Google Ads",
            "Display & Video konverziókövetés",
            "90 nap",
            "HTTP cookie"
          ],
          [
            "IDE",
            "Google DoubleClick",
            "Remarketing és hirdetésmérés",
            "13 hónap",
            "HTTP cookie"
          ],
          [
            "DSID",
            "Google DoubleClick",
            "Bejelentkezett felhasználó remarketingje",
            "2 hét",
            "HTTP cookie"
          ],
          [
            "NID",
            "Google",
            "Remarketing és preferenciák",
            "6 hónap",
            "HTTP cookie"
          ],
          [
            "brevo_cid / sib_cuid",
            "Brevo (SendInBlue)",
            "E-mail kampány konverziókövetés",
            "1 év",
            "HTTP cookie"
          ],
          [
            "GTM-*",
            "Google Tag Manager",
            "Tag konténer és aktiválási logika",
            "Technikai helper",
            "Script"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "7. Harmadik féltől származó SDK-k és külső scriptek"
      },
      {
        "type": "paragraph",
        "text": "Az alábbi SDK-k és external scriptek töltődhetnek be az Orienta weboldalán vagy alkalmazásában. Ezek saját adatkezelési feltételeik szerint is gyűjthetnek adatokat."
      },
      {
        "type": "table",
        "rows": [
          [
            "SDK / pixel neve",
            "Szolgáltató",
            "Cél",
            "Adatkör",
            "Hozzájárulás szükséges"
          ],
          [
            "Google Tag Manager",
            "Google LLC",
            "Tag management, egyéb scriptek betöltése",
            "Nem gyűjt önállóan - a betöltött tagektől függ",
            "Igen, ha nem-szükséges tageket tölt be"
          ],
          [
            "Google Analytics 4",
            "Google LLC",
            "Weboldal- és app-analitika, eseménymérés",
            "client ID, IP (anonymizált), események, oldalak",
            "Igen"
          ],
          [
            "Google Ads Conversion",
            "Google LLC",
            "Konverziókövetés, remarketing listák",
            "gclid, konverziós esemény, device/cookie ID",
            "Igen"
          ],
          [
            "Brevo Web Tracking",
            "Brevo SAS",
            "E-mail kampány nyomon követése, lista tagság",
            "e-mail, nyitás/kattintás, IP, időbélyeg",
            "Igen"
          ],
          [
            "WonderPush SDK",
            "WonderPush SAS",
            "Push értesítési feliratkozás és kézbesítés",
            "push token, device ID, user ID, nyelv",
            "Igen (push engedély külön)"
          ],
          [
            "Stripe.js",
            "Stripe Inc.",
            "Fizetési adatok biztonságos kezelése, fraud-szűrés",
            "kártyaadatok (nem kerülnek Szolgáltatóhoz), device fingerprint",
            "Nem - fizetési funkcióhoz szükséges"
          ],
          [
            "Cloudflare Bot Management",
            "Cloudflare Inc.",
            "Bot-védelem, DDoS-elhárítás, biztonsági forgalomszűrés",
            "IP, HTTP fejlécek, TLS fingerprint",
            "Nem - biztonsági célú, szükséges"
          ],
          [
            "Vercel Edge Network / Hosting",
            "Vercel Inc.",
            "Webalkalmazás kiszolgálása, edge/CDN, deployment és technikai naplózás",
            "IP, HTTP fejlécek, request/log metaadatok, technikai naplók",
            "Nem - szolgáltatás működéséhez szükséges"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "8. Hozzájárulás kezelése és visszavonása"
      },
      {
        "type": "paragraph",
        "text": "Az Orienta weboldal cookie-hozzájárulás-kezelő bannert (Consent Management Platform - CMP) alkalmaz. Az első látogatáskor az Ön explicit hozzájárulása szükséges a nem-szükséges cookie-k aktiválásához."
      },
      {
        "type": "paragraph",
        "text": "8.1. Hozzájárulás megadása"
      },
      {
        "type": "paragraph",
        "text": "Az első látogatás alkalmával megjelenő cookie-banner segítségével kategóriánként fogadhatja el vagy utasíthatja el a cookie-kat."
      },
      {
        "type": "paragraph",
        "text": "Az 'Összes elfogadása' gombra kattintva valamennyi kategória aktiválódik."
      },
      {
        "type": "paragraph",
        "text": "A 'Csak szükséges' opcióval kizárólag az elengedhetetlen technológiák maradnak aktívak."
      },
      {
        "type": "paragraph",
        "text": "A 'Beállítások' menüpont alatt kategóriánként személyre szabhatja a hozzájárulást."
      },
      {
        "type": "paragraph",
        "text": "8.2. Hozzájárulás visszavonása és módosítása"
      },
      {
        "type": "paragraph",
        "text": "Hozzájárulását bármikor visszavonhatja a weboldal alján elérhető 'Cookie-beállítások' linkre kattintva."
      },
      {
        "type": "paragraph",
        "text": "A visszavonás nem érinti a visszavonás előtt végzett adatkezelés jogszerűségét."
      },
      {
        "type": "paragraph",
        "text": "Böngészőjének beállításaiban is törölheti vagy blokkolhatja a cookie-kat - ez azonban a Feltétlenül szükséges kategóriát is érintheti, és zavarhatja a szolgáltatás működését."
      },
      {
        "type": "paragraph",
        "text": "8.3. Böngészőszintű beállítások"
      },
      {
        "type": "paragraph",
        "text": "Az alábbi böngészők cookie-kezelési beállításait az alábbi helyeken érheti el:"
      },
      {
        "type": "paragraph",
        "text": "Google Chrome: Beállítások -> Adatvédelem és biztonság -> Cookie-k és egyéb webhelyadatok"
      },
      {
        "type": "paragraph",
        "text": "Mozilla Firefox: Beállítások -> Adatvédelem és biztonság -> Cookie-k és webhelyadatok"
      },
      {
        "type": "paragraph",
        "text": "Safari: Beállítások -> Adatvédelem -> Cookie-k kezelése"
      },
      {
        "type": "paragraph",
        "text": "Microsoft Edge: Beállítások -> Cookie-k és webhelyadatok"
      },
      {
        "type": "heading",
        "level": 2,
        "text": "9. Harmadik fél opt-out lehetőségek"
      },
      {
        "type": "paragraph",
        "text": "Az alábbi harmadik fél platformoknál közvetlenül is leiratkozhat a nyomon követésről:"
      },
      {
        "type": "table",
        "rows": [
          [
            "Platform",
            "Opt-out lehetőség"
          ],
          [
            "Google Analytics",
            "tools.google.com/dlpage/gaoptout (böngészőbővítmény)"
          ],
          [
            "Google Ads / remarketing",
            "adssettings.google.com"
          ],
          [
            "Brevo (e-mail tracking)",
            "A kapott e-mailekben a Leiratkozás gombra kattintva"
          ],
          [
            "WonderPush (push)",
            "A böngésző / operációs rendszer értesítési beállításaiban"
          ],
          [
            "Általános online hirdetési opt-out",
            "youronlinechoices.com (EU) | optout.aboutads.info (USA)"
          ],
          [
            "NAI opt-out",
            "optout.networkadvertising.org"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "10. Harmadik országba irányuló adattovábbítás"
      },
      {
        "type": "paragraph",
        "text": "Egyes cookie-k és SDK-k adatokat továbbíthatnak az EU/EGT-n kívülre, különösen az Egyesült Államokba. Az érintett szolgáltatók és az alkalmazott garanciák:"
      },
      {
        "type": "table",
        "rows": [
          [
            "Szolgáltató",
            "Székhely",
            "Adattovábbítási garancia"
          ],
          [
            "Google LLC (Analytics, Ads, GTM, OAuth)",
            "USA",
            "EU-USA Data Privacy Framework (DPF); SCC; Google Data Processing Terms"
          ],
          [
            "Cloudflare Inc.",
            "USA",
            "EU-USA DPF; SCC; Cloudflare DPA"
          ],
          [
            "Vercel Inc.",
            "USA / globális",
            "EU-USA DPF; SCC; Vercel Data Processing Addendum"
          ],
          [
            "Stripe Inc.",
            "USA / Írország (EU entitás)",
            "EU-USA DPF; SCC; Stripe Data Processing Agreement"
          ],
          [
            "Brevo SAS",
            "Franciaország (EU)",
            "EU-n belüli feldolgozás; SCC al-feldolgozóknál"
          ],
          [
            "WonderPush SAS",
            "Franciaország (EU)",
            "EEA infrastruktúra; SCC harmadik ország esetén"
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "text": "11. A tájékoztató frissítése"
      },
      {
        "type": "paragraph",
        "text": "Ez a tájékoztató frissülhet, ha új cookie-kat, SDK-kat vagy technológiákat vezet be az Orienta, ha meglévő technológiák megváltoznak, vagy ha jogszabályi változás teszi szükségessé. A lényeges változásokról a weboldalon vagy e-mailben tájékoztatjuk."
      },
      {
        "type": "paragraph",
        "text": "A tájékoztató aktuális verziója mindig a https://orientaplatform.eu oldalon érhető el. A korábbi verziók az adatvédelmi kapcsolattartótól kérhetők."
      },
      {
        "type": "heading",
        "level": 2,
        "text": "12. Kapcsolat és kérelmek"
      },
      {
        "type": "table",
        "rows": [
          [
            "Adatkezelő",
            "Extra SWEET Solutions Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság"
          ],
          [
            "Adatvédelmi kapcsolattartó",
            "Édes Gábor"
          ],
          [
            "E-mail",
            "info@orientaplatform.eu"
          ],
          [
            "Telefon",
            "+36 70 607 2310"
          ],
          [
            "Weboldal",
            "https://orientaplatform.eu"
          ],
          [
            "NAIH",
            "1055 Budapest, Falk Miksa utca 9-11. | ugyfelszolgalat@naih.hu"
          ]
        ]
      },
      {
        "type": "paragraph",
        "text": "Cookie-kezeléssel kapcsolatos kérdéseit, észrevételeit vagy kérelmeit az adatvedelem@orientaplatform.eu e-mail címen fogadjuk. Az Adatkezelési Tájékoztatóban részletezett érintetti jogait (hozzáférés, törlés, helyesbítés, tiltakozás stb.) szintén ezen a csatornán gyakorolhatja."
      }
    ]
  }
] satisfies LegalDocument[];

export function getLegalDocument(pathname: string) {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';

  return legalDocuments.find((document) => document.path.replace(/\/+$/, '') === normalizedPath);
}
